import style from './Button.scss';
import BeatLoader from "react-spinners/BeatLoader";
import { css } from "@emotion/react";
import CircularProgress from '@mui/material/CircularProgress';
import { PropaneRounded } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';


export default function Button(props){

    let disabled = (!props.disabled) ? '' : 'disabled';
    
    let attrs = {
        disabled : disabled,
        style: props.style,
        onClick: props.onClick,
        className: "" + props.className
    };

    let isLoading = false;
    if (props.loader) {
        attrs.onClick = () => {};
        isLoading = true;
        attrs.disabled=true
    }

    if (props.extraStyle) {
        attrs.style = props.extraStyle;
    }

    return (
        <Tooltip title={props.Tooltip} followCursor>
        <button {...attrs} >
            {isLoading ? (
              <div style={{"display": "contents" }}> 
              <a style={{"marginRight":"0.5em"}}>
              <CircularProgress color="inherit" size="1em" />
              </a>
              {props.text}
            </div>
              
            ):(
               <div style={{"display": "contents"}}> 
               {props.startIcon && 
                <a style={{"marginRight":"0.5em"}}>
                    {props.startIcon}
                </a>
               }
                  
                  {props.text}
                </div>
            )}
            
        </button>
        </Tooltip>
    )
}